import { CustomModalNotify } from "../app/shared/components";

const ModalNotifyPlugin = {
    install(Vue) {
        this.EventBus = new Vue();
        Vue.component('modal-notify', CustomModalNotify);
        Vue.prototype.$modalNotify = {
            show(params) {
                ModalNotifyPlugin.EventBus.$emit('show', params);
            },
            hide() {
                ModalNotifyPlugin.EventBus.$emit('hide');
            }
        }
    }
};

export default ModalNotifyPlugin
